import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next' // @ts-nocheck

import {
  SimpleResourceCategoryEntity,
  useResourceCategoryAdminIndex,
  useResourceCategoryFindMany,
} from '@/api'
import { KBSelect, KBSelectProps } from '@/components/atoms'
import { ALL_OPTIONS } from '@/components/utils'
import { MAX_PAGINATION_LIMIT } from '@/utils/constants'
import { isUserClient } from '@/utils/userEnvironment'

interface Option {
  value: number
  label: string
  model?: SimpleResourceCategoryEntity | undefined
}

interface KBResourceCategorySelectProps extends KBSelectProps {
  resourceTypeId?: number
  /**
   * If true, the component will show an "All" option
   */
  includeAllOption?: boolean
}

export const KBResourceCategorySelect: React.FC<
  KBResourceCategorySelectProps
> = (props) => {
  const { t } = useTranslation()
  const { resourceTypeId, includeAllOption, ...restProps } = props
  const [options, setOptions] = useState<Option[]>([])

  const { data, isPending } = isUserClient()
    ? useResourceCategoryFindMany({
        resource_type_id: resourceTypeId,
        limit: MAX_PAGINATION_LIMIT,
      })
    : useResourceCategoryAdminIndex({
        resource_type_id: resourceTypeId,
        limit: MAX_PAGINATION_LIMIT,
      })

  useEffect(() => {
    const _options: Option[] = (data?.result || [])?.map(
      (resource: SimpleResourceCategoryEntity) => ({
        value: resource.id!, //String(resource.id!),
        label: resource.name!,
        model: resource,
      })
    )
    if (includeAllOption) {
      _options.unshift({
        value: ALL_OPTIONS,
        label: t('all.resourceCategories'),
        model: undefined,
      })
    }
    setOptions(_options)
  }, [data, includeAllOption])

  return (
    <KBSelect
      style={{ width: 200 }}
      {...restProps}
      loading={isPending}
      options={options}
      onChange={(value, option) => {
        if (!value || value === ALL_OPTIONS) {
          props.onChange?.(undefined, option)
          return
        }
        const resourceCategoryId = parseInt(value)
        props.onChange?.(resourceCategoryId, option)
      }}
    />
  )
}

export default KBResourceCategorySelect
